import { ICategoryPublicationResponse } from "../../../model/base/response/category-publication-response";
import { ICategoryQuestionAwnserResponse } from "../../../model/base/response/category-question-awnser-response";
import { IQuestionAnwserReponsae } from "../../../model/base/response/question-awnser-respons";
import { Pagination } from "../../../model/paginatiion";


export type QuestionAwnserState = {
  questionAwnser: Pagination<IQuestionAnwserReponsae>;
  categories: ICategoryQuestionAwnserResponse[];
};

export enum ACTION_TYPES {
  loadingData = 'loadingData',
  setCategories = 'setCategories',
}

export const QuestionAwnserReducer = (state: QuestionAwnserState, action: any): QuestionAwnserState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.loadingData:
      return {
        ...state,
        questionAwnser: payload,
      };
      case ACTION_TYPES.setCategories:
        return {
          ...state,
          categories: payload,
        };
  
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}